import { useMemo } from 'react';
import { Box, Chip, Typography } from '@mui/joy';
import { businessToday } from '../businessDay';

const toISO = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

const getQuickPeriods = () => {
    const now = businessToday();
    const today = toISO(now);
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const weekStart = new Date(now);
    const day = weekStart.getDay();
    weekStart.setDate(weekStart.getDate() - (day === 0 ? 6 : day - 1));
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    return [
        { key: 'today',     label: 'Сегодня',  from: today,              to: today },
        { key: 'yesterday', label: 'Вчера',     from: toISO(yesterday),   to: toISO(yesterday) },
        { key: 'week',      label: 'Неделя',    from: toISO(weekStart),   to: today },
        { key: 'month',     label: 'Месяц',     from: toISO(monthStart),  to: today },
    ];
};

const chipSx = {
    cursor: 'pointer', fontWeight: 700, fontSize: 12,
    transition: 'all .15s', px: 2, py: 0.5,
    bgcolor: 'var(--joy-palette-background-level2)',
    border: '1px solid var(--joy-palette-divider)',
    '&:hover': { bgcolor: 'var(--joy-palette-background-level3)', '& .MuiChip-label': { color: 'black' } },
    '& .MuiChip-label': { color: 'white' }
};

export default function DateQuickPicker({ activeKey, onChange, label }) {
    const periods = useMemo(getQuickPeriods, []);

    return (
        <Box>
            {label && (
                <Typography sx={{
                    fontSize: 12, fontWeight: 700,
                    color: 'var(--joy-palette-text-secondary)',
                    mb: 0.8, textTransform: 'uppercase', letterSpacing: '0.04em',
                }}>
                    {label}
                </Typography>
            )}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8 }}>
                {periods.map(p => {
                    const active = activeKey === p.key;
                    return (
                        <Chip key={p.key} size="md"
                            variant={active ? 'solid' : 'outlined'}
                            color={active ? 'primary' : 'neutral'}
                            onClick={() => onChange(p.from, p.to, p.key)}
                            sx={{
                                flex: 1, justifyContent: 'center',
                                cursor: 'pointer', fontWeight: 700, fontSize: 13,
                                bgcolor: active ? p.bg : 'transparent',
                                color: active ? p.color : 'var(--joy-palette-text-tertiary)',
                                borderColor: active ? p.color : 'var(--joy-palette-divider)',
                                transition: 'all .15s',
                                '&:hover': { borderColor: p.color },
                            }}
                        >
                            {p.label}
                        </Chip>
                    );
                })}
            </Box>
        </Box>
    );
}